import styled from "styled-components";

export default styled.div`
  width: 100%;

  .chat-header-component {
    background-color: rgba(218, 218, 218, 0.5);
    backdrop-filter: blur(25px);
    -webkit-backdrop-filter: blur(25px);

    border-radius: 12px 12px 0 0;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    padding: 0.5rem 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .chat-header-left {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    .chat-header-right {
      align-self: stretch;
    }

    .back-arrow {
      display: none;
    }

    .chat-header-component-info {
      display: flex;
      align-items: center;
      gap: 1rem;
      cursor: pointer;
    }
  }

  @media screen and (max-width: 768px) {
    width: 100%;

    .chat-header-component {
      border-radius: 0px 0px 0px 0px;
      display: flex;
      gap: 0.5rem;
      padding-left: 1rem;

      .back-arrow {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .chat-header-component-info {
      }
    }
  }
`;
